import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { widgets } from "src/libs/layouts"
import { ALIGN, ILandingSection, WidgetContent } from "src/modules/pe-landing-module/data/interfaces"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import Dummy from "./Dummy"
import DataContentEditor from "../landing-edit/editors/data-content-editor"


/* Protopia Ecosystem component */
export interface IPEWidgetProps {
    section: ILandingSection
    data: WidgetContent 
}
const PEWidget = ({data, ...props}: IPEWidgetProps): JSX.Element => {
    const [marginLeft]    = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]   = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]     = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]  = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [width]         = useState<string>(getCssDemention( data.width, "100%" ))
    const [height, ]      = useState<string>(getCssDemention( data.height, "inherit" ))

    const [widget, setWidget] = useState<any>(null)

    useEffect(() => {
        addCSSClass(
            `landing-pewidget-${props.section.id}`,
            `.landing-pewidget-${props.section.id} {
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: ${ width };
                max-height: ${ height };
                width: ${ width };
                height: ${ height };
                z-index:1;
            } 
            `
        )
        if(!!data.widgetId) {
            const widgData = widgets()[ data.widgetId ]
            const module = widgData.module 
            const promise:Promise<any> = import( `src/modules/${ module }/widgets/${ data.widgetId}` )
            promise.then(
                response => {                        
                    const WidgetComponent = response.default
                    setWidget( <WidgetComponent {...data.attributes} />)
                },
                error => console.error( error )
            )
        }            
        return () => {
            removeCSSClass(`landing-pewidget-${props.section.id}`)
        }
    },[ ]) 
    
    return <div className='pe-pewidget-container landing-content-container' data-type={data.type}>
        {
            !!data.widgetId
                ?
                <div className={`landing-pewidget landing-pewidget-${props.section.id} ${ data.className || "" } `} style={ data.style || {} } data-content-id={data.id}>
                    {widget}
                    <DataContentEditor data={data} section={props.section} />
                </div>
                :
                <Dummy {...{ 
                    data: {...data, className: `landing-pewidget-${props.section.id}`}, 
                    ...props 
                }} />
        }        
    </div>
}
export default PEWidget

 